module.exports = __webpack_public_path__ + "static/media/294859.63150218.png";